<template>
    <div class="akfooter">
        <footer class="footer">
            <p> 2018-2022 AnyKnew(效率资讯) </p>
        </footer>
    </div>
</template>
<script>
/* eslint-disable */
  export default {
    name: 'akfooter',
    data () {
      return {
      }
    },
    created: function () {
      // var that = this
      // this.$http.get('/self/profile', {}, function (r) {
      //   if (r.status === 0) {
      //     that.username = r.data.profile.username
      //     that.origname = r.data.profile.username
      //     that.avatar = r.data.profile.avatar.replace('/132', '/0')
      //     localStorage.setItem('username', r.data.profile.username)
      //   }
      // })
    },
    computed: {
    },
    components: {},
    methods: {
    }

  }
</script>
<style lang="less">
    .akfooter{
        width:100%;
        position: absolute;
        bottom: 0;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        p{
            color: #999999;
            font-size:12px;
            color:rgba(102,102,102,1);
            line-height:25px;
            text-align:center;
            a{
                color: #999999;
            }
        }
    }
</style>
